import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import { HeaderComponent } from './header/header.component';
import { SiderComponent } from './sider/sider.component';
import { FooterComponent } from './footer/footer.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { BaseComponent } from './base/base.component';
import { LayoutRoutingModule } from './layout-routing.module';
import { ElementModule } from '~shared/element/element.module';

@NgModule({
  declarations: [HeaderComponent, SiderComponent, FooterComponent, BreadcrumbComponent, BaseComponent],
  imports: [
    PerfectScrollbarModule,
    CommonModule,
    NgZorroAntdModule,
    LayoutRoutingModule,
    ElementModule
  ],
  exports: [BreadcrumbComponent]
})
export class LayoutModule { }
